var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreHoriz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "more-horiz"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9997 10.4154C15.2298 10.4154 15.4163 10.2288 15.4163 9.9987C15.4163 9.76858 15.2298 9.58203 14.9997 9.58203C14.7696 9.58203 14.583 9.76858 14.583 9.9987C14.583 10.2288 14.7696 10.4154 14.9997 10.4154Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9997 10.207C15.1147 10.207 15.208 10.1138 15.208 9.9987C15.208 9.88364 15.1147 9.79036 14.9997 9.79036C14.8846 9.79036 14.7913 9.88364 14.7913 9.9987C14.7913 10.1138 14.8846 10.207 14.9997 10.207ZM13.958 9.9987C13.958 9.4234 14.4244 8.95703 14.9997 8.95703C15.575 8.95703 16.0413 9.4234 16.0413 9.9987C16.0413 10.574 15.575 11.0404 14.9997 11.0404C14.4244 11.0404 13.958 10.574 13.958 9.9987Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99967 10.4154C10.2298 10.4154 10.4163 10.2288 10.4163 9.9987C10.4163 9.76858 10.2298 9.58203 9.99967 9.58203C9.76956 9.58203 9.58301 9.76858 9.58301 9.9987C9.58301 10.2288 9.76956 10.4154 9.99967 10.4154Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 10.207C10.1147 10.207 10.208 10.1138 10.208 9.9987C10.208 9.88364 10.1147 9.79036 9.99967 9.79036C9.88461 9.79036 9.79134 9.88364 9.79134 9.9987C9.79134 10.1138 9.88461 10.207 9.99967 10.207ZM8.95801 9.9987C8.95801 9.4234 9.42438 8.95703 9.99967 8.95703C10.575 8.95703 11.0413 9.4234 11.0413 9.9987C11.0413 10.574 10.575 11.0404 9.99967 11.0404C9.42438 11.0404 8.95801 10.574 8.95801 9.9987Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99967 10.4154C5.22979 10.4154 5.41634 10.2288 5.41634 9.9987C5.41634 9.76858 5.22979 9.58203 4.99967 9.58203C4.76956 9.58203 4.58301 9.76858 4.58301 9.9987C4.58301 10.2288 4.76956 10.4154 4.99967 10.4154Z",
    fill: "#656579"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99967 10.207C5.11473 10.207 5.20801 10.1138 5.20801 9.9987C5.20801 9.88364 5.11473 9.79036 4.99967 9.79036C4.88462 9.79036 4.79134 9.88364 4.79134 9.9987C4.79134 10.1138 4.88462 10.207 4.99967 10.207ZM3.95801 9.9987C3.95801 9.4234 4.42438 8.95703 4.99967 8.95703C5.57497 8.95703 6.04134 9.4234 6.04134 9.9987C6.04134 10.574 5.57497 11.0404 4.99967 11.0404C4.42438 11.0404 3.95801 10.574 3.95801 9.9987Z",
    fill: "#656579"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreHoriz);
export default __webpack_public_path__ + "static/media/more-horiz.8b73ecbec56c85ca40863d36c6b21c3b.svg";
export { ForwardRef as ReactComponent };